import React from 'react';
import { Divider, Tab } from 'semantic-ui-react';
import MetricsLiveCard from './MetricsLiveCard';
import MetricsMaintenanceSection from './MetricsMaintenanceSection';
import MetricsSearchSection from './MetricsSearchSection';
import MetricsServerSection from './MetricsServerSection';
import MetricsTrendsSection from './MetricsTrendsSection';
import MetricsUserSection from './MetricsUserSection';

function MetricsTab() {
  return (
    <Tab.Pane className="row content transparent" attached="top">
      <MetricsLiveCard />
      <Divider />
      <MetricsServerSection />
      <Divider />
      <MetricsSearchSection />
      <Divider />
      <MetricsTrendsSection />
      <Divider />
      <MetricsUserSection />
      <Divider />
      <MetricsMaintenanceSection />
    </Tab.Pane>
  );
}

export default MetricsTab;
